/** 登录令牌按北京时间日历日有效（默认 3 天，含签发日） */
export const JWT_CALENDAR_VALIDITY_DAYS = 3;

const SHANGHAI_TZ = 'Asia/Shanghai';

function decodeJwtPayload(token) {
  if (!token || typeof token !== 'string') return null;
  const parts = token.split('.');
  if (parts.length < 2) return null;
  try {
    const base64 = parts[1].replace(/-/g, '+').replace(/_/g, '/');
    const padded = base64 + '='.repeat((4 - (base64.length % 4)) % 4);
    return JSON.parse(atob(padded));
  } catch {
    return null;
  }
}

export function getShanghaiDateString(epochMs = Date.now()) {
  return new Intl.DateTimeFormat('en-CA', {
    timeZone: SHANGHAI_TZ,
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  }).format(new Date(epochMs));
}

/** 北京时间自然日起点（毫秒） */
export function shanghaiDayStartMs(epochMs = Date.now()) {
  const dateStr = getShanghaiDateString(epochMs);
  return Date.parse(`${dateStr}T00:00:00+08:00`);
}

/** 两个时刻之间相差的北京时间自然日数（可为负） */
export function shanghaiCalendarDaysBetween(fromMs, toMs = Date.now()) {
  return Math.floor((shanghaiDayStartMs(toMs) - shanghaiDayStartMs(fromMs)) / 86_400_000);
}

export function parseJwtIssuedAtMs(token) {
  const payload = decodeJwtPayload(token);
  const iat = Number(payload?.iat);
  return Number.isFinite(iat) && iat > 0 ? iat * 1000 : null;
}

/**
 * 登录令牌是否已超过日历有效期。
 * 默认 3 天：签发日算第 1 天，第 4 天 00:00（北京时间）起视为过期。
 */
export function isJwtExpiredByDailyMidnight(token) {
  const issuedAtMs = parseJwtIssuedAtMs(token);
  if (!issuedAtMs) return false;
  return shanghaiCalendarDaysBetween(issuedAtMs) >= JWT_CALENDAR_VALIDITY_DAYS;
}

/** 距离北京时间次日 00:00 的毫秒数 */
export function msUntilNextShanghaiMidnight() {
  const now = new Date();
  const parts = new Intl.DateTimeFormat('en-US', {
    timeZone: SHANGHAI_TZ,
    hour: 'numeric',
    minute: 'numeric',
    second: 'numeric',
    hourCycle: 'h23',
  }).formatToParts(now);
  const get = (type) => Number(parts.find((p) => p.type === type)?.value || 0);
  const hour = get('hour');
  const minute = get('minute');
  const second = get('second');
  return ((23 - hour) * 3600 + (59 - minute) * 60 + (60 - second)) * 1000;
}

/** 距离当前 token 日历有效期结束（北京时间 00:00）的毫秒数 */
export function msUntilJwtCalendarExpiry(token) {
  const issuedAtMs = parseJwtIssuedAtMs(token);
  if (!issuedAtMs) return msUntilNextShanghaiMidnight();
  const expiryMs = shanghaiDayStartMs(issuedAtMs) + JWT_CALENDAR_VALIDITY_DAYS * 86_400_000;
  return Math.max(1000, expiryMs - Date.now());
}

export function clearJwtIfDailyExpired(token, onClear) {
  if (token && isJwtExpiredByDailyMidnight(token)) {
    onClear?.();
    return null;
  }
  return token;
}
